// extracted by mini-css-extract-plugin
export default {"wrapper":"planPaymentRestriction_wrapper__HcifM","titleText":"planPaymentRestriction_titleText__yc8jG"};